var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.999 273.986C507.312 264.61 511.969 252.297 511.969 239.983S507.312 215.357 497.999 205.981L337.989 45.97C328.614 36.657 316.301 32 303.987 32S279.361 36.657 269.985 45.97L13.97 301.988C4.657 311.363 0 323.677 0 335.99S4.657 360.617 13.97 369.992L109.975 465.999C118.94 474.964 131.099 480 143.777 480H499.999C506.627 480 512 474.627 512 467.999V467.999C512 439.278 488.717 415.996 459.996 415.996H355.865L497.999 273.986ZM195.356 211.356L332.614 348.616L265.36 415.996H150.603L70.598 335.99L195.356 211.356Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.a8a0f1cd8e28f138aa8f2d63e65b40a1.svg";
export { ForwardRef as ReactComponent };